<template>
  <div>
    <template>
      <v-layout wrap class="pt-4">
        <v-flex xs12 sm6 class="text-sm-left text-xs-left">
          <v-btn
            depressed
            outline
            color="primary"
            @click="showsearch = true"
            class="ma-0 mr-1 mb-1"
          >
            <v-icon>search</v-icon>&nbsp;{{ $t('Advanced Search') }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 class="text-sm-right text-xs-right">
          <importxlsx :loading="importloading" @onChange="onImport"></importxlsx>
          <exportxlsx :promisedValue="getXlsxData"></exportxlsx>
        </v-flex>
      </v-layout>

      <h3 class="headline">{{ $t('Warranty Number') }}</h3>
      <v-data-table
        :headers="headers"
        :items="dataWarrantyNumber"
        :loading="loading"
        hide-actions
        :pagination.sync="pagination"
        class="elevation-1 mt-4"
      >
        <!-- hide-actions -->
        <template v-slot:items="props">
          <tr>
            <td class="text-sm-center">{{ props.item.warranty_number }}</td>
            <td class="text-sm-center">{{ props.item.used ? 'ใช้แล้ว' : 'ยังไม่ได้ใช้' }}</td>
            <td class="text-sm-center">
              {{ props.item.usedtype[0] ? props.item.usedtype[0] : '-' }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="mt-2">
        <v-pagination
          :total-visible="6"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
      </div>

      <v-dialog v-model="showsearch" width="500px" persistent>
        <v-card>
          <div style="float: right">
            <v-btn @click="showsearch = false" icon><v-icon>close</v-icon></v-btn>
          </div>
          <div class="pa-2 pt-4 pb-3">
            <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
            <!-- Search info -->
            <div>
              <v-layout class="pa-0 ma-0" wrap row>
                <v-flex xs12 sm12 class="form-control pa-1">
                  <label>{{ $t('หมายเลขรับประกันสินค้า') }}</label>
                  <input v-model="filter.warranty_number" class="form-control" type="text" />
                </v-flex>
                <v-flex xs12 sm12 class="form-control pa-1">
                  <label>{{ $t('สถานะ') }}</label>
                  <Multiselect
                    @input="$emit('change', $event)"
                    v-model="filter.status"
                    :options="status"
                    label="text"
                  ></Multiselect>
                </v-flex>
              </v-layout>
            </div>
            <div class="text-xs-center">
              <v-btn @click="clearsearch" outline color="grey">Clear</v-btn>
              <v-btn @click="onsearch" color="primary">Search</v-btn>
            </div>
          </div>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import importxlsx from '@/components/elements/importxlsx.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'

export default {
  components: {
    Multiselect,
    importxlsx,
    exportxlsx
  },
  props: ['selectedDate', 'onSearch'],
  data() {
    return {
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      offset: 0,
      limit: 100,
      pagetmp: 1,
      pageNumber: 1,
      headers: [
        {
          text: 'หมายเลขรับประกันสินค้า',
          value: 'warranty_number',
          align: 'center',
          sortable: true
        },
        { text: 'สถานะ', value: 'status', align: 'center', sortable: true },
        { text: 'Gift/Purchase', value: 'usedtype', align: 'center', sortable: true }
      ],
      filter: {
        warranty_number: '',
        status: ''
      },
      dataWarrantyNumber: [],
      loading: false,
      status: [
        { text: 'ใช้แล้ว', value: true },
        { text: 'ยังไม่ได้ใช้', value: false }
      ],
      showsearch: false,
      importloading: false,
      isExport: false
    }
  },
  mounted() {
    this.getWarrantyNumber()
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  methods: {
    getXlsxData() {
      return new Promise(async (resolve) => {
        this.isExport = true
        var data = await this.getWarrantyNumber()

        resolve(
          data.map((el) => {
            return {
              หมายเลขรับประกันสินค้า: el.warranty_number,
              สถานะ: el.used ? 'ใช้งานแล้ว' : 'ยังไม่ได้ใช้งาน',
              'Gift/Purchase': el.usedtype[0] ? el.usedtype[0] : '-'
            }
          })
        )

        this.isExport = false
        await this.getWarrantyNumber()
      })
    },
    getWarrantyNumber() {
      return new Promise((resolve) => {
        var vm = this
        var limit

        if (vm.isExport) {
          limit = vm.total
        } else {
          limit = vm.limit
        }

        var data = {
          pageid: vm.selectedBot.pageid, // required
          warranty_number: vm.filter.warranty_number,
          used: vm.filter.status.value,
          // start_date: vm.selectedDate.start,
          // end_date: vm.selectedDate.end,
          limit: limit,
          offset: vm.offset
        }
        vm.loading = true
        api.getLamyWarrantyImport(data, (err, response) => {
          if (response.responsecode == 200) {
            vm.dataWarrantyNumber = response.data
            vm.total = response.total
            vm.loading = false
            resolve(response.data)
          } else {
            console.log(err)
            return
          }
        })
      })
    },
    onImport(item) {
      this.importloading = true
      var data = {
        pageid: this.selectedBot.pageid,
        files: item[0]
      }
      api.postLamyWarrantyImport(data, async (err, response) => {
        this.importloading = false
        if (response && response.responsecode == 200) {
          await this.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
          this.getWarrantyNumber()
        } else {
          await this.$swal.fire({
            text: 'ข้อมูลไม่ถูกต้อง'
          })
        }
      })
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getWarrantyNumber()
      }
    },
    onsearch() {
      this.limit = 100
      this.offset = 0
      this.getWarrantyNumber()
      this.showsearch = false
    },
    clearsearch() {
      ;(this.filter = {
        warranty_number: '',
        status: ''
      }),
        this.onsearch()
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/lamy/LamyWarrantyNumber.vue